/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from '@essex/styled-components'

export const Container = styled.div`
	display: flex;
	justify-content: flex-start;
`

export const icons = {
	delete: { iconName: 'Delete' },
}
